import "./aside.less";
export default function asideController(
    $scope,
    $rootScope,
    $uibModalInstance,
    $timeout,
    declinedBookings,
    repeatedBooking,
    houseService,
    siteService,
    Auth,
    Basket,
    BasketToCheckout,
    navService,
    asideFactory,
    Users,
    $location
) {
    $scope.siteService = siteService;

    // declinedBookings is resolve on aside caller
    if (declinedBookings) {
        //If declined Bookings Scroll down for the user to Notice
        $timeout(function () {
            customScrollHandler();
        });
    }

    const customScrollHandler = function () {
        var elemID = "basket-id-" + declinedBookings[0].ID;
        var elem = $("#" + elemID);
        var pos = elem.offset().top - 125;

        angular.element("#basket-content").animate(
            {
                scrollTop: pos,
            },
            600
        );
    };

    $scope.selectedBookings = Basket.currentBookings;
    $scope.houseCategory = houseService.searchFilter.houseCategory;
    $scope.houseType = houseService.searchFilter.houseType;

    $scope.mainNavItems = navService.mainNavItems;

    Users.getAuthenticatedUser().then(
        (user) => {
            $scope.user = user;
        },
        () => {
            $scope.user = null;
        }
    );

    $scope.basketOverlayClass = true;

    // AUTHENTICATION
    $scope.logout = function () {
        Basket.resetBasket();

        //avail param : e
        Auth.logout();

        // $scope.ok(e);
    };

    // AUTHENTICATION
    $scope.login = function () {
        //avail param : e
        Auth.login();

        // $scope.ok(e);
    };

    $scope.closeAside = function () {
        asideFactory.close();
    };

    $scope.checkout = () => {
        Basket.getBookingActivity(); // const activity =
        Basket.getBookings(); // const bookings =

        /**
         * // TO DO ::: LOW ::: mobile checkout button
         * this button has disabled for now
         * issues regarding promises goToCheckout
         */

        // asideFactory.close().then(
        //     () => {
        //         // BasketToCheckout.goToCheckout(activity, bookings).then(
        //         //     (res) => {
        //         //         console.log(res);
        //         //     },
        //         //     (err) => {
        //         //         console.log(err);
        //         //     }
        //         // );
        //     },
        //     (err) => {
        //         console.log(err);
        //     }
        // );
    };

    $scope.select = function ($event, path) {
        $scope.ok($event);

        $location.path(path);
    };

    $scope.ok = function (e) {
        $uibModalInstance.close("login"); // accepts vars to pass back to modal caller

        e.stopPropagation();
    };

    $scope.cancel = function (e) {
        $uibModalInstance.dismiss("cancel");

        e.stopPropagation();
    };

    //Directives inside the modal needs a hook so they can request that the modal should close
    var CloseModalEventListener = $rootScope.$on(
        "close-modal-from-inside",
        function (event, obj) {
            $scope.ok(obj.event);
        }
    );
    $scope.$on("$destroy", CloseModalEventListener);

    //listen to event - hides book now button
    var AnyRepeatableEventListener = $scope.$on(
        "any-repeabable-collapsed",
        function (event, obj) {
            $scope.anyRepeatableCollapsed = obj.collapsed;
        }
    );

    $scope.$on("$destroy", AnyRepeatableEventListener);

    //$scope.someVar = someVar; // EXAMPLE !! NOT IN USE - get vars passed from modal caller! ( index.js )
    if (repeatedBooking) {
        var args = { repeatedBooking: repeatedBooking };

        $timeout(function () {
            $rootScope.$broadcast("show-tooltip-repeatable", args);
        }, 500);
    }

    // When user scrolls to bottom of basket -> remove overlay / or reactivate!
    jQuery(function ($) {
        $("#basket-content").on("scroll", function () {
            if (
                $(this).scrollTop() + $(this).innerHeight() >=
                $(this)[0].scrollHeight
            ) {
                $scope.$apply(function () {
                    $scope.basketOverlayClass = false;
                });
            } else {
                $scope.$apply(function () {
                    $scope.basketOverlayClass = true;
                });
            }
        });
    });
}
